export default __webpack_public_path__ + "img/51e2b39ea46aa4ee999320d7244a2e4d.svg";